import React, { useState, useEffect } from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import { ArrowRight, Download } from 'lucide-react';

const titles = [
  'Full-Stack Web Developer',
  'IT Technical Support',
  'IT Systems & Web Dev',
  'Cloud & API Integrator'
];

interface TechPillItem {
  id: string;
  name: string;
  borderColor: string;
  icon: React.ReactNode;
}

const allTechPills: TechPillItem[] = [
  {
    id: 'claude',
    name: 'Claude Code',
    borderColor: 'rgba(217, 119, 6, 0.4)',
    icon: <img src="/assets/claude Icon.png" alt="Claude Code" className="pill-img-icon" />
  },
  {
    id: 'antigravity',
    name: 'Google AntiGravity',
    borderColor: 'rgba(66, 133, 244, 0.4)',
    icon: <img src="/assets/ANTI GRAVITY ICON.png" alt="Google AntiGravity" className="pill-img-icon" />
  },
  {
    id: 'codex',
    name: 'OpenAI Codex',
    borderColor: 'rgba(16, 163, 127, 0.4)',
    icon: <img src="/assets/codex-icon.webp" alt="OpenAI Codex" className="pill-img-icon" />
  },
  {
    id: 'laravel',
    name: 'Laravel',
    borderColor: 'rgba(255, 45, 32, 0.4)',
    icon: <img src="/assets/Laravel Icon.png" alt="Laravel" className="pill-img-icon" />
  },
  {
    id: 'canva',
    name: 'Canva Design',
    borderColor: 'rgba(0, 196, 204, 0.4)',
    icon: <img src="/assets/Canva Icon.jpg" alt="Canva" className="pill-img-icon" style={{ borderRadius: '4px' }} />
  },
  {
    id: 'sql',
    name: 'SQL Database',
    borderColor: 'rgba(0, 97, 138, 0.4)',
    icon: <img src="/assets/SQL Icon.png" alt="MySQL" className="pill-img-icon" />
  },
  {
    id: 'capcut',
    name: 'CapCut Video',
    borderColor: 'rgba(255, 0, 80, 0.4)',
    icon: <img src="/assets/CAPCUT ICON.png" alt="CapCut" className="pill-img-icon" />
  },
  {
    id: 'react',
    name: 'React.js',
    borderColor: 'rgba(97, 218, 251, 0.4)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="spin-react-pill">
        <circle cx="12" cy="12" r="2.5" fill="#61DAFB"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" stroke="#61DAFB" strokeWidth="1.5" transform="rotate(0 12 12)"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" stroke="#61DAFB" strokeWidth="1.5" transform="rotate(60 12 12)"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" stroke="#61DAFB" strokeWidth="1.5" transform="rotate(120 12 12)"/>
      </svg>
    )
  },
  {
    id: 'ts',
    name: 'TypeScript',
    borderColor: 'rgba(49, 120, 198, 0.4)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="3" fill="#3178C6"/>
        <path d="M7 9H13M10 9V17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <path d="M14 15.5C14.5 16.3 15.3 16.8 16.3 16.8C17.3 16.8 18 16.2 18 15.4C18 14.5 17 14.1 16 13.7C14.8 13.2 14.1 12.6 14.1 11.4C14.1 10.3 15.1 9.5 16.3 9.5C17.2 9.5 17.9 9.9 18.4 10.6" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    id: 'js',
    name: 'JavaScript',
    borderColor: 'rgba(247, 223, 30, 0.4)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="3" fill="#F7DF1E"/>
        <path d="M11 11V16.5C11 17.3 10.4 18 9.5 18C8.6 18 8 17.4 8 16.5" stroke="#111" strokeWidth="2" strokeLinecap="round"/>
        <path d="M14 15.5C14.5 16.3 15.3 16.8 16.3 16.8C17.3 16.8 18 16.2 18 15.4C18 14.5 17 14.1 16 13.7C14.8 13.2 14.1 12.6 14.1 11.4C14.1 10.3 15.1 9.5 16.3 9.5C17.2 9.5 17.9 9.9 18.4 10.6" stroke="#111" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    id: 'php',
    name: 'PHP Backend',
    borderColor: 'rgba(119, 123, 180, 0.4)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="6" width="20" height="12" rx="3" stroke="#777BB4" strokeWidth="2"/>
        <path d="M6 9V15M6 12H8.5C9.3 12 10 11.3 10 10.5C10 9.7 9.3 9 8.5 9H6Z" stroke="#777BB4" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M14 9V15M14 12H16.5C17.3 12 18 11.3 18 10.5C18 9.7 17.3 9 16.5 9H14Z" stroke="#777BB4" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M11 9V15" stroke="#777BB4" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    id: 'api',
    name: 'RESTful APIs',
    borderColor: 'rgba(0, 230, 118, 0.4)',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="#00E676" strokeWidth="2"/>
        <path d="M12 3C14.5 6 16 9 16 12C16 15 14.5 18 12 21C9.5 18 8 15 8 12C8 9 9.5 6 12 3Z" stroke="#00E676" strokeWidth="1.5"/>
        <path d="M3 12H21" stroke="#00E676" strokeWidth="1.5"/>
      </svg>
    )
  }
];

const positionClasses = [
  'pill-claude',
  'pill-antigravity',
  'pill-codex',
  'pill-laravel',
  'pill-react',
  'pill-mysql'
];

export const HeroSection: React.FC = () => {
  const { setIsResumeModalOpen } = usePortfolio();
  const [titleIndex, setTitleIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  // 5-Second Bouncy Elastic Tech Orbit Pill State
  const [pillStartIndex, setPillStartIndex] = useState(0);
  const [isPillFlipping, setIsPillFlipping] = useState(false);
  const [isPillEntering, setIsPillEntering] = useState(false);

  useEffect(() => {
    const currentTitle = titles[titleIndex];
    const typingSpeed = isDeleting ? 40 : 80;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setDisplayedText(currentTitle.substring(0, displayedText.length + 1));
        if (displayedText === currentTitle) {
          setTimeout(() => setIsDeleting(true), 1800);
        }
      } else {
        setDisplayedText(currentTitle.substring(0, displayedText.length - 1));
        if (displayedText === '') {
          setIsDeleting(false);
          setTitleIndex((prev) => (prev + 1) % titles.length);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, titleIndex]);

  // 5-Second Bouncy Spring Physics Tech Swap Timer
  useEffect(() => {
    const pillInterval = setInterval(() => {
      setIsPillFlipping(true);
      setTimeout(() => {
        setPillStartIndex((prev) => (prev + 2) % allTechPills.length);
        setIsPillFlipping(false);
        setIsPillEntering(true);
        setTimeout(() => {
          setIsPillEntering(false);
        }, 650);
      }, 450); // 450ms exit bouncy phase
    }, 5000); // Triggers every 5 seconds

    return () => clearInterval(pillInterval);
  }, []);

  const activePills = Array.from({ length: 6 }, (_, i) => 
    allTechPills[(pillStartIndex + i) % allTechPills.length]
  );

  return (
    <section id="hero" className="hero">
      <div className="container hero-grid">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="status-dot"></span>
            <span>Open for Web Development & IT Opportunities</span>
          </div>

          <h1 className="hero-title">
            Hi, I'm <span style={{ color: 'var(--accent-cyan)' }}>Lorenz Saldivar</span>
          </h1>

          <div className="typewriter-wrap">
            <span className="typewriter-text">{displayedText}</span>
          </div>

          <p className="hero-subtitle">
            Entry-Level Information Technology Graduate passionate about web development and IT operations. I leverage <strong>AI-Assisted Development</strong> (Claude Code, Google AntiGravity, Codex) alongside modern web tech to build clean, responsive, and functional applications.
          </p>

          {/* AI-Assisted Developer Callout Card */}
          <div
            style={{
              background: 'var(--bg-card)',
              border: '1px solid var(--border-color)',
              borderRadius: 'var(--radius-md)',
              padding: '0.85rem 1.2rem',
              marginBottom: '2rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.85rem',
              maxWidth: '580px',
              boxShadow: 'var(--shadow-sm)'
            }}
          >
            <div
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: 'rgba(245, 158, 11, 0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="#F59E0B" stroke="#D97706" strokeWidth="1.5"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-title)' }}>
                AI-Assisted Development Workflow
              </div>
              <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                Powered by <strong>Claude Code</strong>, <strong>Google AntiGravity</strong>, and <strong>OpenAI Codex</strong> for rapid prototyping & efficient engineering.
              </div>
            </div>
          </div>

          <div className="hero-cta">
            <a href="#projects" className="btn btn-primary">
              <span>View Projects</span>
              <ArrowRight size={18} />
            </a>
            <button className="btn btn-secondary" onClick={() => setIsResumeModalOpen(true)}>
              <Download size={18} />
              <span>Digital Resume</span>
            </button>
          </div>

          <div className="hero-metrics">
            <div className="metric-item">
              <span className="metric-num">BSIT</span>
              <span className="metric-label">Fresh Graduate</span>
            </div>
            <div className="metric-item">
              <span className="metric-num">AI<span>+</span></span>
              <span className="metric-label">Assisted Dev</span>
            </div>
            <div className="metric-item">
              <span className="metric-num">6<span>+</span></span>
              <span className="metric-label">Handled Systems</span>
            </div>
          </div>
        </div>

        {/* Hero Visual Avatar & 5-Second Dynamic Bouncy Tech Orbit Pills */}
        <div className="hero-visual">
          <div className="avatar-wrapper">
            <img
              src="/assets/IMG_3731.jpg"
              alt="Lorenz Saldivar — BSIT Graduate & Web Developer"
              className="avatar-img"
              style={{ objectFit: 'cover', objectPosition: 'center center' }}
            />
          </div>

          {activePills.map((pill, idx) => (
            <div
              key={`${pill.id}-${idx}`}
              className={`floating-pill ${positionClasses[idx]} ${
                isPillFlipping ? 'morphing-spin' : isPillEntering ? 'bouncy-enter' : ''
              }`}
              style={{ borderColor: pill.borderColor }}
              title={`Active Skill: ${pill.name}`}
            >
              {pill.icon}
              <span>{pill.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
